export default class AttachmentModel {
  id: string | null;
  ticket_id: string | null;
  ticket_progress_id: string | null;
  media_url: string | null;
  image: string | null;
  desc: string | null;
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  constructor() {
    this.id = null;
    this.ticket_id = null;
    this.ticket_progress_id = null;
    this.image = null;
    this.desc = null;
    this.media_url = null;
    this.deleted_at = null;
    this.created_at = null;
    this.updated_at = null;
  }
}
